import React from "react";
import "./PagesCss/home.css";
import Hero from "../component/Hero";
import HeroImage from "../component/HeroImage";
import YouTubeVideo from "../component/YouTubeVideo";
import Contato from "./Contato";

function Home() {
  return (
    <React.StrictMode>
      <HeroImage />
      <div className="div-home"></div>
      <main id="home">
        <Hero />
        <YouTubeVideo
          videoId="llIxGgPy53c"
          title="CQL Advogados - Vídeo Institucional"
        />
        <Contato />
      </main>
    </React.StrictMode>
  );
}

export default Home;
